import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const QATable = () => {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <label className="ml-4 mt-2">
              NAJČEŠĆE POSTAVLJANA PITANJA / ODGOVORI
            </label>
            <p className="ml-4">
              Nabavka: Usluga Obuka za interne proveravače sistema kvaliteta ISO
              i Uvodjenje i certifikacija ISO standarda
            </p>
          </TableRow>
          <TableRow>
            <TableCell>R.b</TableCell>
            <TableCell>Datum/vreme pitanja</TableCell>
            <TableCell>Pitanje</TableCell>
            <TableCell>Odgovori</TableCell>
            <TableCell>Datum/vreme odgovora</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default QATable;
